import axiosPost from "../axiosPost";


export const SFVoucherIns = async (params = {}, credentials) => {
    const body = {
        service: "SFVoucherIns",
        params: {
            SFVoucherTipo: params?.SFVoucherTipo,
            numeroDesde: params?.numeroDesde,
            numeroHasta: params?.numeroHasta,
            cantidad: params?.cantidad || '0',
            SFVoucherFechaDesde: params?.SFVoucherFechaDesde,
            SFVoucherFechaHasta: params?.SFVoucherFechaHasta,
            tipoDeDocumentoCod: params?.tipoDeDocumentoCod,
            usuarioNroDeDocumentoX: params?.usuarioNroDeDocumentoX,
            usuarioSexo: params?.usuarioSexo,
            usuarioFechaDeNacimiento: params?.usuarioFechaDeNacimiento,
            usuarioApellidos: params?.usuarioApellidos,
            usuarioNombres: params?.usuarioNombres,
        },
    };

    const result = await axiosPost(body, credentials);
    return result;
}



// SFVoucherIns

// SFVoucherTipo - Tipo: String, Requerido.
// numeroDesde - Tipo: String, Requerido.
// numeroHasta - Tipo: String, Requerido.
// SFVoucherFechaDesde - Tipo: Fecha/Hora, Requerido.
// SFVoucherFechaHasta - Tipo: Fecha/Hora, Requerido.
// tipoDeDocumentoCod - Tipo: String, Requerido.
// usuarioNroDeDocumentoX - Tipo: String, Requerido.
// usuarioSexo - Tipo: String, Requerido.
// usuarioFechaDeNacimiento - Tipo: Fecha/Hora, Requerido.
// usuarioApellidos - Tipo: Número, Requerido.
// usuarioNombres - Tipo: Número, Requerido.
